exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* <!-- @import '~styles/bootstrap.custom'; */\n.Sidebar {\n  background: red;\n  height: calc(100vh - 50px);\n  position: fixed;\n  top: 50px;\n  width: 220px;\n  z-index: 1; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Sidebar/Sidebar.scss
// module id = 1600
// module chunks = 0